function SkeletonBar({ width, height = 12 }: { width: string | number; height?: number }) {
	return (
		<div
			style={{
				width,
				height,
				borderRadius: "var(--radius-2)",
				background:
					"linear-gradient(90deg, var(--skeleton-base) 0%, var(--skeleton-highlight) 50%, var(--skeleton-base) 100%)",
				backgroundSize: "200% 100%",
				animation: "izanagi-skeleton-shimmer 1.4s ease-in-out infinite",
			}}
		/>
	);
}

function SkeletonRow({ align }: { align: "left" | "right" }) {
	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				gap: 6,
				alignItems: align === "right" ? "flex-end" : "flex-start",
				marginBottom: 16,
			}}
		>
			<SkeletonBar width="60%" />
			<SkeletonBar width="80%" />
			<SkeletonBar width="40%" />
		</div>
	);
}

export function ChatSkeleton() {
	return (
		<div
			data-testid="chat-view-skeleton"
			className="flex flex-1 flex-col"
			style={{ padding: "8px 4px", animation: "izanagi-fade-in 0.12s ease-out both" }}
		>
			<SkeletonRow align="left" />
			<SkeletonRow align="right" />
			<SkeletonRow align="left" />
		</div>
	);
}
